import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function BlogPage() {
  const categories = ['الكل', 'دليل القبول', 'التخصصات', 'الاختبارات', 'الجامعات', 'المنح', 'حياة جامعية'];
  const [activeCategory, setActiveCategory] = useState('الكل');

  const blogPosts = [
    {
      id: 1,
      title: 'دليل شامل للقبول في الجامعات السعودية 2024',
      excerpt: 'كل ما تحتاج معرفته عن إجراءات القبول والمواعيد المهمة للعام الدراسي القادم',
      category: 'دليل القبول',
      image: 'https://public.readdy.ai/ai/img_res/fe1afd5959cc8ea0fbabc242e5e8f5c9.jpg',
      date: '15 يناير 2024',
      readTime: '5 دقائق',
      author: 'فريق التحرير'
    },
    {
      id: 2,
      title: 'أفضل التخصصات الجامعية المطلوبة في سوق العمل',
      excerpt: 'تعرف على التخصصات الأكثر طلباً والتي توفر فرص عمل واعدة في المستقبل',
      category: 'التخصصات',
      image: 'https://readdy.ai/api/search-image?query=Modern%20university%20classroom%20with%20advanced%20technology%2C%20students%20working%20on%20computers%20and%20tablets%2C%20bright%20natural%20lighting%2C%20contemporary%20educational%20environment%2C%20collaborative%20learning%20space%2C%20professional%20photography%2C%20clean%20minimalist%20design%2C%20high%20quality%2C%20inspiring%20atmosphere&width=800&height=500&seq=blog-002&orientation=landscape',
      date: '12 يناير 2024',
      readTime: '7 دقائق',
      author: 'د. أحمد السعيد'
    },
    {
      id: 3,
      title: 'نصائح للتحضير لاختبارات القدرات والتحصيلي',
      excerpt: 'استراتيجيات فعالة ونصائح عملية لتحقيق أعلى الدرجات في الاختبارات',
      category: 'الاختبارات',
      image: 'https://readdy.ai/api/search-image?query=Focused%20student%20studying%20with%20books%20and%20laptop%20in%20modern%20library%2C%20bright%20natural%20lighting%2C%20organized%20study%20materials%2C%20peaceful%20learning%20environment%2C%20professional%20photography%2C%20clean%20aesthetic%2C%20high%20quality%2C%20motivational%20atmosphere%2C%20simple%20background&width=800&height=500&seq=blog-003&orientation=landscape',
      date: '10 يناير 2024',
      readTime: '6 دقائق',
      author: 'أ. سارة محمد'
    },
    {
      id: 4,
      title: 'مقارنة شاملة بين الجامعات الحكومية والأهلية',
      excerpt: 'الفروقات الأساسية والمميزات والعيوب لكل نوع لمساعدتك في اتخاذ القرار الصحيح',
      category: 'الجامعات',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Saudi%20university%20campus%20aerial%20view%2C%20contemporary%20architecture%20with%20Islamic%20design%20elements%2C%20green%20landscaping%20and%20courtyards%2C%20students%20walking%20on%20pathways%2C%20bright%20sunny%20day%2C%20professional%20architectural%20photography%2C%20high%20quality%2C%20inspiring%20educational%20environment&width=800&height=500&seq=blog-004&orientation=landscape',
      date: '8 يناير 2024',
      readTime: '8 دقائق',
      author: 'د. خالد العتيبي'
    },
    {
      id: 5,
      title: 'دليل المنح الدراسية المتاحة للطلاب السعوديين',
      excerpt: 'فرص المنح الداخلية والخارجية وكيفية التقديم عليها بنجاح',
      category: 'المنح',
      image: 'https://readdy.ai/api/search-image?query=Happy%20student%20receiving%20scholarship%20certificate%2C%20graduation%20cap%20and%20diploma%2C%20bright%20celebratory%20atmosphere%2C%20professional%20photography%2C%20joyful%20moment%2C%20simple%20clean%20background%2C%20high%20quality%2C%20inspiring%20educational%20achievement%2C%20warm%20lighting&width=800&height=500&seq=blog-005&orientation=landscape',
      date: '5 يناير 2024',
      readTime: '10 دقائق',
      author: 'أ. نورة الشمري'
    },
    {
      id: 6,
      title: 'الحياة الجامعية: نصائح للطلاب الجدد',
      excerpt: 'كيف تستفيد من تجربتك الجامعية وتحقق التوازن بين الدراسة والأنشطة',
      category: 'حياة جامعية',
      image: 'https://readdy.ai/api/search-image?query=Group%20of%20diverse%20university%20students%20socializing%20in%20modern%20campus%20courtyard%2C%20laughing%20and%20studying%20together%2C%20bright%20sunny%20day%2C%20contemporary%20architecture%2C%20professional%20photography%2C%20friendly%20atmosphere%2C%20high%20quality%2C%20vibrant%20colors%2C%20inspiring%20student%20life&width=800&height=500&seq=blog-006&orientation=landscape',
      date: '3 يناير 2024',
      readTime: '5 دقائق',
      author: 'فريق التحرير'
    }
  ];

  const filteredPosts = activeCategory === 'الكل' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === activeCategory);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 pt-32 pb-24">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-saudi-gold-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 font-cairo">
            المدونة
          </h1>
          <p className="text-xl text-white/90 font-tajawal">
            مقالات ونصائح تساعدك في رحلتك التعليمية
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Blog Posts Grid */}
        {filteredPosts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer hover:scale-105"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="bg-primary-900 text-white px-4 py-1.5 rounded-full text-xs font-bold font-tajawal">
                      {post.category}
                    </span>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 font-cairo group-hover:text-primary-900 transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 font-tajawal text-sm mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>

                  <div className="flex items-center justify-between text-sm text-gray-500 font-tajawal pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        <span>{post.date}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-2 text-sm text-gray-600 font-tajawal">
                      <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-full">
                        <i className="ri-user-line text-primary-900"></i>
                      </div>
                      <span>{post.author}</span>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-6">
              <i className="ri-article-line text-4xl text-gray-400"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2 font-cairo">
              لا توجد مقالات
            </h3>
            <p className="text-gray-600 font-tajawal">
              لا توجد مقالات في هذا التصنيف حالياً
            </p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
